 
  export const Period = {
    Day: 29,
    Week: 28,
    Month: 26,
};